export default [
  { invoiceno: "001257490",
    orderid: "01",
    custname: "Harsh Dedhia",
    email: "harsh@gmail.com",
    status: "Dispatch",
    amount: "299",
    shipto:"Nahur",
    storename: "D-MART 3",
    orderitems: "ABC"
  },
  { invoiceno: "001257490",
    orderid: "02",
    custname: "Sumit Jaiswal",
    email: "sumit@gmail.com",
    status: "Transit",
    amount: "299",
    shipto:"Thane",
    storename: "D-MART 2",
    orderitems: "XYZ"
  },
  { invoiceno: "001257490",
    orderid: "03",
    custname: "Mohnish Thandassery",
    email: "mohnish@gmail.com",
    status: "Delivered",
    amount: "299",
    shipto:"Mulund",
    storename: "D-MART",
    orderitems: "ABC"
  }
];
